// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Matching Band';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        Provides a link and style number for the band specially designed to work
        with the setting.
      </p>
    </div>
  );
}
